import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  private _copyrightYear: string;

  constructor() {}

  ngOnInit() {
    this._copyrightYear = new Date().getFullYear().toString();
  }

  public get copyrightYear() {
    return this._copyrightYear;
  }
}
